import React, { useState, useRef } from 'react';
import firebase from '../firebase';

import 'firebase/firestore';
import 'firebase/auth';

import ChatMessage from './ChatMessage';

import { useCollectionData } from 'react-firebase-hooks/firestore';

const auth = firebase.auth();
const firestore = firebase.firestore();


function Chat() {

    const messagesRef = firestore.collection('messages');
    const query = messagesRef.orderBy('createdAt').limit(25);

    const [messages] = useCollectionData(query, { idField: 'id' });

    const [formValue, setFormValue] = useState('');


    //will re render any time messages changes which is real time

    //type any - don't know what kind of form event onSbumit needs

    //const dummy: React.RefObject<HTMLInputElement> = React.createRef();
    const dummy = useRef<HTMLSpanElement>(null);

    const sendMessage = async (e: any) => {
        e.preventDefault();
        const { uid } = auth.currentUser!;
        const txt = formValue;
        setFormValue('');
        await messagesRef.add({
            text: txt,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            uid
        });

        if (null !== dummy.current){
            dummy.current.scrollIntoView({ behavior: 'smooth' });
        }

    }


    return (
        <div >
            <div style={{width: '58vh',padding: '1vw', height: '20vh', marginTop: '5vh', overflowY: 'scroll', display: 'flex', flexDirection: 'column', borderStyle: 'solid', backgroundColor: 'white'}}>
                {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} />)}
                <span ref={dummy}></span>

            </div>
            
            <form onSubmit={sendMessage} >
                <input size={49} value={formValue} onChange={(e) => setFormValue(e.target.value)} />
                <button type="submit">Enter</button>
            </form>
        </div>
    )
}

export default Chat;